// constants
import { ExpeditionsActionTypes } from "./constants";

//Action
export interface ExpeditionsActionType {
  type:
    | ExpeditionsActionTypes.GET_LIST_EXPEDITIONS_ERROR
    | ExpeditionsActionTypes.GET_LIST_EXPEDITIONS_SUCCESS
    | ExpeditionsActionTypes.GET_LIST_EXPEDITIONS
    | ExpeditionsActionTypes.CREATE_EXPEDITION
    | ExpeditionsActionTypes.CREATE_EXPEDITION_SUCCESS
    | ExpeditionsActionTypes.CREATE_EXPEDITION_ERROR
    | ExpeditionsActionTypes.GET_EXPEDITION
    | ExpeditionsActionTypes.GET_EXPEDITION_SUCCESS
    | ExpeditionsActionTypes.GET_EXPEDITION_ERROR
    | ExpeditionsActionTypes.UPDATE_EXPEDITION
    | ExpeditionsActionTypes.UPDATE_EXPEDITION_SUCCESS
    | ExpeditionsActionTypes.UPDATE_EXPEDITION_ERROR
    | ExpeditionsActionTypes.UPDATE_STATUS_EXPEDITION
    | ExpeditionsActionTypes.UPDATE_STATUS_EXPEDITION_SUCCESS
    | ExpeditionsActionTypes.UPDATE_STATUS_EXPEDITION_ERROR
    | ExpeditionsActionTypes.DELETE_EXPEDITION
    | ExpeditionsActionTypes.DELETE_EXPEDITION_SUCCESS
    | ExpeditionsActionTypes.DELETE_EXPEDITION_ERROR;
  payload: {} | string;
}

//Interfaces
interface ExpeditionsData {
  iteam?: any[];
  total?: number;
  country?: string;
  keyword?: string;
  limit?: number;
  skip?: number;
  owner?: string;
}

interface ExpeditionCreate {
  country: string;
  comment: string;
  description: string;
  expeditionDate: Date;
  from: any;
  mode: string;
  name: string;
  price: number;
  productImage: string;
  quantity: number;
  transporterName: string;
  transporterPhone: string;
  weight: number;
}

interface ExpeditionUpdate {
  comment: string;
  description: string;
  expeditionDate: Date;
  from: any;
  mode: string;
  name: string;
  price: number;
  productImage: string;
  quantity: number;
  transporterName: string;
  transporterPhone: string;
  weight: number;
  damaged?: number;
}

interface GetExpedition {
  id: string;
}

interface DeleteExpedition {
  ids: string[];
}

//Expedition_List
export const expeditionsGetListSuccess = (
  actionType: string,
  data: ExpeditionsData | {}
): ExpeditionsActionType => ({
  type: ExpeditionsActionTypes.GET_LIST_EXPEDITIONS_SUCCESS,
  payload: { actionType, data },
});

export const expeditionsGetListError = (
  actionType: string,
  error: string
): ExpeditionsActionType => ({
  type: ExpeditionsActionTypes.GET_LIST_EXPEDITIONS_ERROR,
  payload: { actionType, error },
});

export const getExpeditionsList = (
  keyword: string = "",
  limit: number = 10,
  skip: number = 0,
  owner: string = "",
  country: string = "ic",
  startDate?: string,
  endDate?: string
): ExpeditionsActionType => ({
  type: ExpeditionsActionTypes.GET_LIST_EXPEDITIONS,
  payload: { keyword, limit, skip, owner, country, startDate, endDate },
});

//Create Expedition
export const createExpeditionSuccess = (
  actionType: string,
  data: ExpeditionCreate | {}
): ExpeditionsActionType => ({
  type: ExpeditionsActionTypes.CREATE_EXPEDITION_SUCCESS,
  payload: { actionType, data },
});
export const createExpeditionError = (
  actionType: string,
  error: string
): ExpeditionsActionType => ({
  type: ExpeditionsActionTypes.CREATE_EXPEDITION_ERROR,
  payload: { actionType, error },
});
export const createExpedition = (
  country: string,
  comment: string,
  description: string,
  expeditionDate: Date,
  from: any,
  mode: string,
  name: string,
  price: number,
  productImage: string,
  quantity: number,
  transporterName: string,
  transporterPhone: string,
  weight: number
): ExpeditionsActionType => ({
  type: ExpeditionsActionTypes.CREATE_EXPEDITION,
  payload: {
    country,
    comment,
    description,
    expeditionDate,
    from,
    mode,
    name,
    price,
    productImage,
    quantity,
    transporterName,
    transporterPhone,
    weight,
  },
});

//Update Expedition
export const updateExpeditionSuccess = (
  actionType: string,
  data: ExpeditionUpdate | {}
): ExpeditionsActionType => ({
  type: ExpeditionsActionTypes.UPDATE_EXPEDITION_SUCCESS,
  payload: { actionType, data },
});
export const updateExpeditionError = (
  actionType: string,
  error: string
): ExpeditionsActionType => ({
  type: ExpeditionsActionTypes.UPDATE_EXPEDITION_ERROR,
  payload: { actionType, error },
});

export const updateExpedition = (
  id: string,
  data: ExpeditionUpdate
): ExpeditionsActionType => ({
  type: ExpeditionsActionTypes.UPDATE_EXPEDITION,
  payload: { id, ...data },
});

//Update Status Expedition
export const updateStatusExpeditionSuccess = (
  actionType: string,
  data: ExpeditionUpdate | {}
): ExpeditionsActionType => ({
  type: ExpeditionsActionTypes.UPDATE_STATUS_EXPEDITION_SUCCESS,
  payload: { actionType, data },
});
export const updateStatusExpeditionError = (
  actionType: string,
  error: string
): ExpeditionsActionType => ({
  type: ExpeditionsActionTypes.UPDATE_STATUS_EXPEDITION_ERROR,
  payload: { actionType, error },
});

export const updateStatusExpedition = (id: string): ExpeditionsActionType => ({
  type: ExpeditionsActionTypes.UPDATE_STATUS_EXPEDITION,
  payload: { id },
});

//GET Expedition

export const getExpeditionSuccess = (
  actionType: string,
  data: GetExpedition | {}
): ExpeditionsActionType => ({
  type: ExpeditionsActionTypes.GET_EXPEDITION_SUCCESS,
  payload: { actionType, data },
});
export const getExpeditionError = (
  actionType: string,
  error: string
): ExpeditionsActionType => ({
  type: ExpeditionsActionTypes.GET_EXPEDITION_ERROR,
  payload: { actionType, error },
});

export const getExpedition = (id: string): ExpeditionsActionType => ({
  type: ExpeditionsActionTypes.GET_EXPEDITION,
  payload: { id },
});

//DELETE Expedition

export const deleteExpeditionSuccess = (
  actionType: string,
  data: DeleteExpedition | {}
): ExpeditionsActionType => ({
  type: ExpeditionsActionTypes.DELETE_EXPEDITION_SUCCESS,
  payload: { actionType, data },
});
export const deleteExpeditionError = (
  actionType: string,
  error: string
): ExpeditionsActionType => ({
  type: ExpeditionsActionTypes.DELETE_EXPEDITION_ERROR,
  payload: { actionType, error },
});

export const deleteExpedition = (ids: string[]): ExpeditionsActionType => ({
  type: ExpeditionsActionTypes.DELETE_EXPEDITION,
  payload: { ids },
});
